/**
 * ContrastFeature - Handles all contrast/color mode features
 * Modes: monochrome, darkHighContrast, brightHighContrast, contrastMode
 */
import BaseFeature from './BaseFeature.js';

export default class ContrastFeature extends BaseFeature {
    constructor(widget, options = {}) {
        super(widget, options);
        this.mode = options.mode || 'contrastMode';
        this.cssClassMap = {
            monochrome: 'dhA11y-monochrome',
            darkHighContrast: 'dhA11y-dark-high-contrast',
            brightHighContrast: 'dhA11y-bright-high-contrast',
            contrastMode: 'dhA11y-contrast-mode'
        };
    }

    enable() {
        super.enable();
        // Disable other contrast modes first
        this._disableOtherModes();
        const cls = this.cssClassMap[this.mode];
        if (cls) {
            this.addBodyClass(cls);
        }
    }

    disable() {
        super.disable();
        const cls = this.cssClassMap[this.mode];
        if (cls) {
            this.removeBodyClass(cls);
        }
    }

    /**
     * Disable other contrast modes to prevent conflicts
     */
    _disableOtherModes() {
        const contrastKeys = ['monochrome', 'darkHighContrast', 'brightHighContrast', 'contrastMode'];
        contrastKeys.forEach(key => {
            if (key !== this.options.key && this.widget.isFeatureActive(key)) {
                this.widget.toggleFeature(key, false);
            }
        });
    }
}
